import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FILTER_HISTORY_STORAGE_QUERY_KEY, getFilterHistory, setFilterHistory } from './utils';

const useRemoveFilterHistory = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (id: string) => {
      const prev = getFilterHistory();
      const filtered = prev.filter((x) => x.id !== id);
      if (filtered.length === prev.length) return;

      setFilterHistory(filtered);
      return filtered;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: FILTER_HISTORY_STORAGE_QUERY_KEY,
      });
    },
  });

  return mutation;
};

export default useRemoveFilterHistory;
